/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base box-shadow styles for the Soft UI Dashboard React.
 * You can add new box-shadow using this file.
 * You can customized the box-shadow for the entire Soft UI Dashboard React using thie file.
 */

// Soft UI Dashboard React Base Styles
import colors from "assets/theme/base/colors";

// Soft UI Dashboard React Helper Functions
import boxShadow from "assets/theme/functions/boxShadow";

const { black, white, info, inputColors, tabs } = colors;

// Softer, modern shadow scale. Single-layer for everyday elevation,
// double-layered for prominent surfaces (modals, popovers).
const boxShadows = {
  xs: boxShadow([0, 1], [2, 0], black.main, 0.04),
  sm: boxShadow([0, 2], [8, 0], black.main, 0.05),
  md: boxShadow([0, 4], [16, -2], black.main, 0.06),
  lg: `${boxShadow([0, 8], [24, -4], black.main, 0.08)}, ${boxShadow(
    [0, 4],
    [8, -2],
    black.main,
    0.04
  )}`,
  xl: `${boxShadow([0, 20], [40, -8], black.main, 0.12)}, ${boxShadow(
    [0, 8],
    [16, -4],
    black.main,
    0.06
  )}`,
  xxl: boxShadow([0, 16], [48, -8], black.main, 0.08),
  inset: boxShadow([0, 1], [2, 0], black.main, 0.05, "inset"),
  navbarBoxShadow: `${boxShadow([0, 0], [1, 1], white.main, 0.8, "inset")}, ${boxShadow(
    [0, 2],
    [12, 0],
    black.main,
    0.04
  )}`,
  buttonBoxShadow: {
    // No permanent shadow on flat buttons (modern look).
    // Only a subtle lift on hover and focus ring on keyboard nav.
    main: "none",
    stateOf: boxShadow([0, 4], [12, -2], black.main, 0.12),
    stateOfNotHover: boxShadow([0, 0], [0, 3], info.main, 0.4),
  },
  inputBoxShadow: {
    focus: boxShadow([0, 0], [0, 2], inputColors.boxShadow, 1),
    error: boxShadow([0, 0], [0, 2], inputColors.error, 0.6),
    success: boxShadow([0, 0], [0, 2], inputColors.success, 0.6),
  },
  sliderBoxShadow: {
    thumb: boxShadow([0, 1], [13, 0], black.main, 0.2),
  },
  tabsBoxShadow: {
    indicator: boxShadow([0, 1], [5, 1], tabs.indicator.boxShadow, 1),
  },
  // Website-inspired shadows
  soft: boxShadow([0, 1], [2, 0], black.main, 0.04),
  glow: boxShadow([0, 20], [60, -20], "#e8b53b", 0.5),
};

export default boxShadows;
